import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IAuthState {
  phoneNumber: string;
  invitationCode?: string;
  changePasswordRequest: boolean;
  loginAt: number;
}

const initialState: IAuthState = {
  phoneNumber: "",
  changePasswordRequest: false,
  loginAt: 0,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuthAction: (state) => {
      state.phoneNumber = "";
      state.changePasswordRequest = false;
      state.loginAt = 0;
      state.invitationCode = "";
    },
    phoneNumberSectionAction: (
      state,
      action: PayloadAction<Pick<IAuthState, "invitationCode" | "phoneNumber">>,
    ) => {
      state.phoneNumber = action.payload.phoneNumber;
      state.invitationCode = action.payload.invitationCode;
      state.changePasswordRequest = false;
      state.loginAt = Date.now();
    },
    setPasswordAction: (state) => {
      state.changePasswordRequest = false;
    },
    verifyPasswordAction: (state) => {
      state.changePasswordRequest = false;
    },
    changePasswordAction: (state) => {
      state.loginAt = Date.now();
      state.changePasswordRequest = true;
    },
    resendOtpAction: (state) => {
      state.loginAt = Date.now();
    },
  },
});

export const {
  phoneNumberSectionAction,
  resetAuthAction,
  setPasswordAction,
  verifyPasswordAction,
  changePasswordAction,
  resendOtpAction,
} = authSlice.actions;

export default authSlice.reducer;
